import React from 'react';
import HMSButton from '../ui/HMSButton';
import PitToPortLocations from './PitToPortLocations';

/* PIT TO PORT Section - Full Width, first on the HOW tab of a cargo delivery */
/**
 * DeliveryPitToPortSection
 * The classic card around PitToPortLocations (mines and delivery places from
 * CRM, Chris's walk-through for the 1 November go-live). Presentational only:
 * the stops live on formData.route_locations and save with the delivery.
 */
const renderButton = ({ action, label, onClick, testId }) => (
  action === 'add' ? (
    <HMSButton variant="secondary" size="compact" onClick={onClick} data-testid={testId}>
      + {label}
    </HMSButton>
  ) : (
    <HMSButton variant="dangerGhost" size="compact" onClick={onClick} aria-label={label} title={label}>
      Remove
    </HMSButton>
  )
);

const DeliveryPitToPortSection = ({
  formData,
  handleInputChange,
  units,
  inlineCrmCreate,
  pendingCreatedPartners,
}) => (
  <div className="delivery-section-card ptp-section" data-testid="pit-to-port-section">
    <div className="delivery-section-header-row">
      <h2 className="delivery-section-header">Pit to Port</h2>
    </div>
    <PitToPortLocations
      formData={formData}
      handleInputChange={handleInputChange}
      units={units}
      inlineCrmCreate={inlineCrmCreate}
      pendingCreatedPartners={pendingCreatedPartners}
      renderButton={renderButton}
    />
  </div>
);

export default DeliveryPitToPortSection;
